import { render } from "./TransfersOffcanves.vue?vue&type=template&id=320e857a&scoped=true"
import script from "./TransfersOffcanves.vue?vue&type=script&lang=js"
export * from "./TransfersOffcanves.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./TransfersOffcanves.vue?vue&type=style&index=1&id=320e857a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320e857a"]])

export default __exports__